import { z } from "zod";

const downloadableReportTypes = ["CartonProduction", "ZFoldUsage", "Trim", "ErrorsAndAvailability", "OEE"] as const;
export const downloadableReportTypeSchema = z.enum(downloadableReportTypes);

export type DownloadableReportType = z.infer<typeof downloadableReportTypeSchema>;

export const normalizeDownloadableReportType = (
	reportType: string | null | undefined,
): DownloadableReportType | undefined => {
	if (reportType === "MaterialUsage") {
		return "ZFoldUsage";
	}

	return downloadableReportTypeSchema.safeParse(reportType).data;
};

export const downloadScheduledReportRequestSchema = z.object({
	startDate: z.string().min(1),
	endDate: z.string().min(1),
	timezoneId: z.string().min(1),
	reportType: downloadableReportTypeSchema,
});

export type DownloadScheduledReportRequest = z.infer<typeof downloadScheduledReportRequestSchema>;
